<div class="ssp-header">
  @if (config.title) {
  <p class="ssp-title" data-testid="settings-side-panel-title">{{ config.title }}</p>
  }
  @if (config.showCloseButton) {
  <button type="button" class="ssp-close-btn" data-testid="settings-side-panel-close-btn" (click)="close()" aria-label="Close">
    <i class="fa-solid fa-xmark"></i>
  </button>
  }
</div>

<div class="ssp-body" data-testid="settings-side-panel-body">
  @if (isTemplate) {
  <ng-container [ngTemplateOutlet]="content"></ng-container>
  }
  @if (isComponent) {
  <ng-container *ngComponentOutlet="content; inputs: config.initialState || {}"></ng-container>
  }
  @if (isString) {
  <div [innerHTML]="content"></div>
  }
  <div #domContainer></div>
</div>
